<template>
  <el-dialog :visible="dialogvisible" @close="dialogvisible = false">
    <div class="cropper-wrapper">
      <div>
        <!-- 上传 -->
        <!-- <input type="file" accept="image/*" @change="onSelect" /> -->
        <el-upload class="" action :show-file-list="false" :auto-upload="false"
          :on-change="onSelect" multiple>
          <el-button size="small" type="primary">重新选择图片</el-button>
        </el-upload>
        <!-- 裁剪区域 -->
        <div v-if="img" class="cropper-box">
          <vue-cropper
            ref="cropper"
            :img="img"
            :autoCrop="true"
            :fixed="true"
            :fixedNumber="ratio"
            :autoCropWidth="cropWidth"
            :autoCropHeight="cropHeight"
            :outputType="outputType"
            :outputSize="outputSize"
            :info="true"
            :full="true"
            :canMove="true"
            :canMoveBox="true"
            :centerBox="true"
            />
        </div>
        <!-- 操作按钮 -->
        <div v-if="img" class="actions">
          <button @click="handleCrop">确认裁剪</button>
          <button @click="reset">取消</button>
        </div>
      </div>
  
  
      <!-- 预览 -->
      <div v-if="preview" class="preview">
        <img :src="preview" />
      </div>
    </div>
  </el-dialog>
</template>

<script>
import { VueCropper } from 'vue-cropper'

export default {
  name: 'ImageCropper',
  components: { VueCropper },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    imgFile: {
      type: Object,
      default: () => {}
    },
    ratio: {
      type: Array,
      default: () => [1, 1] // 比例
    },
    cropWidth: {
      type: Number,
      default: 800
    },
    cropHeight: {
      type: Number,
      default: 800
    },
    outputType: {
      type: String,
      default: 'png'
    },
    outputSize: {
      type: Number,
      default: 1
    },
    minWidth: {
      type: Number,
      default: 800
    },
    minHeight: {
      type: Number,
      default: 800
    }
  },
  data() {
    return {
      img: '',
      preview: '',
      dialogvisible: this.visible
    }
  },
  watch: {
    imgFile(val) {
      if (val) this.onSelect(val)
    },
    visible(val) {
      this.dialogvisible = val
    }
  },
  mounted() {
    // this.dialogvisible = this.visible
    // console.log('this.dialogvisible', this.dialogvisible,this.visible)
  },
  methods: {
    onSelect(e) {
      // console.log('dddd',e)
      this.preview = ''
      // this.img = e.raw
      // return
      // const file = e.target.files[0]
      const file = e.raw
      if (!file) return

      const reader = new FileReader()
      reader.onload = (ev) => {
        const image = new Image()
        image.onload = () => {
          // if (image.width < this.minWidth || image.height < this.minHeight) {
          //   alert(`图片分辨率不能低于 ${this.minWidth}x${this.minHeight}`)
          //   return
          // }
          this.img = ev.target.result
          // console.log('this.img',this.img)
        }
        image.src = ev.target.result
      }
      reader.readAsDataURL(file)
    },

    handleCrop() {
      // this.$refs.cropper.getCropData((base64) => {
      //   this.resizeTo800(base64)
      // })
      this.$refs.cropper.getCropBlob((blob) => {
        const img = new Image()
        img.src = URL.createObjectURL(blob)

        img.onload = () => {
          const canvas = document.createElement('canvas')
          const ctx = canvas.getContext('2d')

          canvas.width = 800
          canvas.height = 800

          ctx.drawImage(img, 0, 0, 800, 800)

          canvas.toBlob((newBlob) => {
            this.preview = URL.createObjectURL(newBlob)

            // 对外抛出
            this.$emit('success', {
              blob: this.blobToFile(newBlob),
              // url: URL.createObjectURL(newBlob)
            })
          }, 'image/png', 1)
        }
        // const url = URL.createObjectURL(blob)
        // console.log('bloburl', blob)
        // console.log('url', url)
        // this.preview = url

        // this.$emit('success', {
        //   blob: this.blobToFile(blob),
        //   url
        // })
      })
    },
    resizeTo800(base64) {
      const img = new Image()
      img.src = base64

      img.onload = () => {
        const canvas = document.createElement('canvas')
        const ctx = canvas.getContext('2d')

        canvas.width = 800
        canvas.height = 800

        // 强制绘制成 800x800
        ctx.drawImage(img, 0, 0, 800, 800)

        canvas.toBlob((blob) => {
          // 👉 这里就是最终 800x800 图片
          const url = URL.createObjectURL(blob)
          console.log('bloburl', blob)
          console.log('url', url)
          this.preview = url
          this.$emit('success', {
          blob: this.blobToFile(blob),
          url
        })
        }, 'image/jpeg', 0.9)
      }
    },
    blobToFile(blob, filename = 'image.jpg') {
      return new File([blob], filename, {
        type: blob.type || 'image/jpeg'
      })
    },
    reset() {
      this.img = ''
      this.preview = ''
    }
  }
}
</script>

<style scoped>
.cropper-wrapper {
  display: flex;
  /* flex-direction: column; */
  gap: 12px;
}

.cropper-box {
  width: 400px;
  height: 400px;
  margin: 15px 0;
}

.actions button {
  margin-right: 10px;
}

.preview img {
  width: 200px;
  border: 1px solid #ccc;
}
</style>
